/**
 * @ngdoc Directive
 * @name vrm-validation-installation-id
 * @example
 *
 * <vrm-validation-installation-id />
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmValidationInstallationId', vrmValidationInstallationId);

    /* @ngInject */
    function vrmValidationInstallationId() {

        return {
            restrict: 'A',
            require: 'ngModel',
            link: link
        };

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         * @param ngModel
         */
        function link($scope, $element, $attr, ngModel) {
            var installationId = function(modelValue) {
                if ($scope.device === 'vgr_ver' || $scope.device === 'shs')
                    return true;
                return _.isString(modelValue) && modelValue.length >= 12;
            };
            var imei = function(modelValue) {
                if ($scope.device !== 'vgr_ver')
                    return true;
                return _.isString(modelValue) && modelValue.length >= 15;
            };
            var serialNumber = function(modelValue) {
                if ($scope.device !== 'shs') {
                    return true;
                }
                return _.isString(modelValue) && modelValue.length == 11;
            };

            $scope.$watch('device', function(device) {
                if (device) {
                    ngModel.$validate();
                }
            }, true);
            ngModel.$validators.installationId = installationId;
            ngModel.$validators.imei = imei;
            ngModel.$validators.serialNumber = serialNumber;
        }
    }
})();
